<template>
  <div class="create-project-block container my-3">
    <h5 class="create-project-header ml-3">
      {{ $resourceString["common.addtobasket"] }}
    </h5>
    <button
      type="button"
      class="wf-modal-button-close btn button-full"
      @click="closeModal"
    >
      <span
        class="png-icon png-icon-icons-symbols--k-txtclose"
        aria-label="Close modal"
      />
    </button>
    <div class="ml-3 pl-1">
      <step-three></step-three>
    </div>
    <div class="modal-footer border-0 mt-5 pr-0">
      <div class="justify-content-between w-100  row">
        <button class="btn btn-outline-primary" @click="closeModal">
          {{ $resourceString["virtualtray.Savetray.Cancel.Button"] }}
        </button>
        <span>
          <button
            class="btn btn-primary"
            @click.prevent="addItemToCart"
            :disabled="getContentWizardData.step3.length == 0 || OrderSampleEnabled"
          >
          {{ $resourceString["common.addtobasket"] }}
          </button>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import StepThree from "../content-wizard-modal/steps/StepThree.vue";
export default {
  components: {
    StepThree
  },
  computed: {
    ...mapGetters({
      getContentWizardData: "contentWizard/getContentWizardData",
      getSelectedProduct: "contentWizard/getSelectedProduct",
      OrderSampleEnabled: "productDetail/getisOrderSampleEnabled",
    })
  },

  created() {
    this.isOrderSampleEnabled();
  },

  methods: {
    ...mapActions({
      addToCart: "newBasketPage/addToCart",
      addCompareToBasket: "myProject/addCompareToBasket",
      resetContent: "contentWizard/resetContent",
      isOrderSampleEnabled: "productDetail/isOrderSampleEnabled",
    }),

    hideModal(name) {
      this.$modal.hide(name + "-modal");
      this.resetContent();
    },

    closeModal() {
      this.hideModal("add-to-basket");
    },
    async addItemToCart() {
      let data = this.getContentWizardData.step3.map(color => ({
        sellingStyleNumber: this.getSelectedProduct.styleNumber,
        sellingColorNumber: color.colorNumber,
        colorNumber: color.colorNumber,
        quantity: 1.0,
        vehicleId: "",
        isTrayItem: false,
        isProjectItem: true,
        colorName: color.colorName
      }));

      await this.addCompareToBasket(data);
      this.closeModal();
    }
  },
  beforeDestroy(){
    this.resetContent();
  }
};
</script>
